/*
 * @Author: Teemo Ding
 * @Date: 2022-03-24 16:03:06
 * @LastEditTime: 2022-04-28 15:30:01
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/voucher/index.ts
 */
import { post, get } from 'src/tools/server';

const getStoreVoucher = (params) => {
  return get<any>(`/portal/discount/voucherPage`, params || {});
};

const postStoreVoucher = (body) => {
  return post<any>(`/portal/discount/voucher`, body, {
    returnWholeData: true,
    handleErrorAsResolve: true,
  });
};

const getVouchersListPage = (body, startIndex, size) => {
  return post<any>(
    `/portal/discount/voucherListPage/${startIndex}/${size}`,
    body || {},
    {},
  );
};

const draftStoreVoucher = (body) => {
  return post<any>(`/portal/discount/voucher/toDraft`, body, {});
};

const archiveStoreVoucher = (body) => {
  return post<any>(`/portal/discount/voucher/archive`, body, {});
};

const publishStoreVoucher = (body) => {
  return post<any>(`/portal/discount/voucher/issue`, body, {
    returnWholeData: true,
    handleErrorAsResolve: true,
  });
};

const duplicateStoreVoucher = (body) => {
  return post<any>(`/portal/discount/voucher/duplicate`, body, {});
};
const issueStoreVoucher = (body) => {
  return post<any>(`/portal/discount/voucher/issue`, body, {});
};

const getDbRelated = (body, params) => {
  return post<any>(`/portal/discount/voucher/pageMeta`, body, params || {});
};
const getEligibleCustomers = (body) => {
  return post<any>(`/portal/discount/eligibleCustomer`, body, {});
};

const getVouchersList = (body, startIndex, size) => {
  return post<any>(
    `/portal/discount/vouchers/${startIndex}/${size}`,
    body || {},
    {},
  );
};

export {
  getStoreVoucher,
  getDbRelated,
  getEligibleCustomers,
  postStoreVoucher,
  draftStoreVoucher,
  archiveStoreVoucher,
  publishStoreVoucher,
  getVouchersList,
  duplicateStoreVoucher,
  issueStoreVoucher,
  getVouchersListPage,
};
